<template>
  <div>
    <ul class="form-list cos-tab-form-list form-list-vertical">
      <li>
        <div class="form-label"><label>{{$t('cos.language')}}</label></div>
        <div class="form-input">
          <select class="tc-15-select m language-select" v-model="LanguageEdit">
            <option v-for="(label, key) in LanguageMap" :key="`language-${key}`" :value="key"
              :selected="key===LanguageEdit">{{label}}
            </option>
          </select>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { tips } from '@/scripts/tools/utils';
import { store } from '@/scripts/store';
import storage, { Storage } from '@/scripts/tools/storage';

const storagePrefix = 'general.';

export default {
  props: {
    disabledBtn: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    const Language = store.localeLanguage || storage.get(`${storagePrefix}Language`) || 'zh';
    return {
      LanguageMap: {
        zh: this.$t('cos.chinese'),
        en: this.$t('cos.english'),
      },
      Language,
      LanguageEdit: Language,
    };
  },
  computed: {
    isSame() {
      return (
        this.LanguageEdit === this.Language
      );
    },
    disabledSave() {
      return this.isSame;
    },
  },
  watch: {
    // 触发禁用保存按钮
    disabledSave() {
      this.$emit('update:disabledBtn', this.disabledSave);
    },
  },
  methods: {
    save() {
      if (this.disabledSave) return;
      this.update('Language');
      tips.success(
        this.$t('core.success', { msg: this.$t('core.save') }),
      );
    },
    update(key, editVal) {
      if (this[`${key}Edit`] !== this[key]) {
        if (editVal === undefined) editVal = this[`${key}Edit`];
        storage.add(storagePrefix + key, editVal);
        this[key] = editVal;
        if (key === 'Language') {
          window.location.reload();
        }
      }
    },
    resetDefaultValue() {
      this.LanguageEdit = Storage.getDefaultValue(`${storagePrefix}Language`);
    },
  },
};
</script>

<style>
</style>
